import { __rest } from "tslib";
import classNames from 'classnames';
import toArray from 'rc-util/lib/Children/toArray';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
export const SpaceCompactItemContext = React.createContext(null);
export const useCompactItemContext = (prefixCls, direction) => {
    const compactItemContext = React.useContext(SpaceCompactItemContext);
    const compactItemClassnames = React.useMemo(() => {
        if (!compactItemContext)
            return '';
        const { compactDirection, isFirstItem, isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return classNames({
            [`${prefixCls}-compact${separator}item`]: true,
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl',
        });
    }, [prefixCls, direction, compactItemContext]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames,
    };
};
export const NoCompactStyle = ({ children }) => (React.createElement(SpaceCompactItemContext.Provider, { value: null }, children));
const CompactItem = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    return (React.createElement(SpaceCompactItemContext.Provider, { value: otherProps }, children));
};
const Compact = (props) => {
    const { getPrefixCls, direction: directionConfig } = React.useContext(ConfigContext);
    const { size = 'middle', direction, block, prefixCls: customizePrefixCls, className, children } = props, restProps = __rest(props, ["size", "direction", "block", "prefixCls", "className", "children"]);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const clx = classNames(prefixCls, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: direction === 'vertical',
    }, className);
    const compactItemContext = React.useContext(SpaceCompactItemContext);
    const childNodes = toArray(children);
    const nodes = React.useMemo(() => childNodes.map((child, i) => {
        const key = (child && child.key) || `${prefixCls}-item-${i}`;
        return (React.createElement(CompactItem, { key: key, compactSize: size, compactDirection: direction, isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)), isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem)) }, child));
    }), [size, childNodes, compactItemContext]);
    // =========================== Render ===========================
    if (childNodes.length === 0) {
        return null;
    }
    return (React.createElement("div", Object.assign({ className: clx }, restProps), nodes));
};
export default Compact;
